import InitAnchorLinks from './atoms/anchorLinks'
import { initializeSelectMenu } from './select-menu/select-menu-init'
import "../scss/main.scss";

InitAnchorLinks()
initializeSelectMenu()
